
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon icon--cart",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.8 33.1H21c-.7 0-1.2-.4-1.6-1L8.8 6.9h-5c-.9 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7h6.1c.7 0 1.2.4 1.6 1l2.3 5.4h39.7c.6 0 1.1.2 1.3.8.3.4.3 1 .2 1.6l-7.7 19.8c-.3.6-.8 1-1.5 1zm-23.6-3.4h22.6L51 13.3H15.2l7 16.4zM24.3 47.5c-3.2 0-5.8-2.6-5.8-5.8 0-3.2 2.6-5.8 5.8-5.8s5.8 2.6 5.8 5.8c-.1 3.3-2.6 5.8-5.8 5.8zm0-8.1c-1.3 0-2.4 1.1-2.4 2.4 0 1.3 1.1 2.4 2.4 2.4 1.3 0 2.4-1.1 2.4-2.4 0-1.4-1.1-2.4-2.4-2.4zM41.8 47.5c-3.2 0-5.8-2.6-5.8-5.8 0-3.2 2.6-5.8 5.8-5.8 3.2 0 5.8 2.6 5.8 5.8 0 3.3-2.6 5.8-5.8 5.8zm0-8.1c-1.3 0-2.4 1.1-2.4 2.4 0 1.3 1.1 2.4 2.4 2.4 1.3 0 2.4-1.1 2.4-2.4.1-1.4-1-2.4-2.4-2.4z"}})])
          )
        }
      }
    